import React from 'react'
import { Platform } from 'react-native'
import { FadeIn, FadeOut } from 'react-native-reanimated'
import Icon, { IconProps } from '@ui/elements/Icon'
import Loader from '@ui/elements/Loader'

interface Props {
  loading: boolean
  iconProps?: IconProps
}

const DURATION = 300
const DELAY = 0

const entering = FadeIn.duration(DURATION).delay(DELAY)
const exiting = FadeOut.duration(0).delay(DELAY)

// On web, entering/exiting animations can conflict with react-freeze
// causing rendering issues and crashes when toggling icons
const shouldAnimate = Platform.OS !== 'web'

export default function IconWithLoading({ loading, iconProps }: Props) {
  const icon = iconProps?.name

  if (loading)
    return (
      <Loader
        loading={loading}
        iconProps={iconProps}
        entering={shouldAnimate ? entering : undefined}
        exiting={shouldAnimate ? exiting : undefined}
      />
    )

  if (!icon) return null

  return <Icon {...iconProps} />
}
